import { Route, Routes } from 'react-router-dom'
import RequireRole from '../../common/components/RequireRole'
import { BackofficePermissionsEnum as Permissions } from '../../common/enums/backOfficePermissionsEnum'
import { Movements } from '../../modules/movements/Movements'
import { SpectrumBankAccounts } from '../../modules/movements/spectrum-bank-accounts/SpectrumBankAccounts'
import { SuspensedView } from '../PrivateRoutes'

export const MovementsRouting = () => {
  return (
    <Routes>
      <Route
        path='list'
        element={
          <RequireRole roles={Permissions.MOVIMIENTOS_ALL}>
            <SuspensedView>
              <Movements />
            </SuspensedView>
          </RequireRole>
        }
      />
      <Route
        path='bank-accounts'
        element={
          <RequireRole roles={Permissions.ACCOUNT_VALIDATED.LIST}>
            <SuspensedView>
              <SpectrumBankAccounts />
            </SuspensedView>
          </RequireRole>
        }
      />
    </Routes>
  )
}
